import { render, staticRenderFns } from "./CategoriesRow.vue?vue&type=template&id=af62b20e&scoped=true&"
import script from "./CategoriesRow.vue?vue&type=script&lang=js&"
export * from "./CategoriesRow.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesRow.vue?vue&type=style&index=0&id=af62b20e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af62b20e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcategories-row%2FCategoriesRow.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports